import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogImageViewerComponent } from 'src/app/shared/components/dialog-image-viewer/dialog-image-viewer.component';

@Injectable({
  providedIn: 'root'
})
export class ImageViewerService {

  constructor(
    private dialog: MatDialog
  ) { }

  openImageViewerDialog(src: string[], index?: number): Observable<any> {
    return this.dialog.open(DialogImageViewerComponent, {
      closeOnNavigation: true,
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'full-screen-dialog',
      backdropClass: 'black-overlay',
      maxHeight: '100vh',
      maxWidth: '100vw',
      data: {
        src,
        index
      },
    }).afterClosed();
  }

}
